import { apiEndpoints } from '@constants';
import { client } from '@utils';

const getAccessRequestsList = () => (
  client.authorized.get(apiEndpoints.globalAccess)
);

const requestAccess = data => (
  client.authorized.post(apiEndpoints.globalAccess, data)
);

const cancelAccessRequest = id => (
  client.authorized.delete(`${apiEndpoints.globalAccess}/${id}`)
);

const editAccessRequest = (id, data) => (
  client.authorized.put(`${apiEndpoints.globalAccess}/${id}`, data)
);

export {
  getAccessRequestsList,
  cancelAccessRequest,
  requestAccess,
  editAccessRequest
};

